import { initializeK8sMenu } from './initialize.menu';
import { initializeK8sPages } from './initialize.pages';
import { initializeK8sRedux } from './initialize.redux';
import { initializeK8sGetStarted } from './initialize.getStarted';
import { initializeK8SProtectedAssetDetails } from './initialize.protectedAssetDetails';
import initializeK8SProtectedAssetTable from './protectedAsset/initialize';
import { addItemsToMenu } from './initializeK8sAddItemsToMenu';
import { initialAwsEnvironmentTabs } from './initialize.awsEnv';
import { initializeEnvironmetsDefs } from './EnvironmetsDefs/initialize';
import { initializeCveDrawer } from './services/cveDrawerRegistry/cveDrawerRegistry.initialize';
import { initialAzureEnvironmentTabs } from './initialize.azureEnv';
import { initializePolicies } from './pages/policy/initialize';
import { initializeEventsActions } from './eventsDefs/initialize';
import { initializeDrawerInfoFields } from './Drawers/initialize.drawers.infoFields';
import initializeExclusionWorkload from './exclusion/initialize';
import { initializeActiveFeatures } from './initialize.activeFeatures';
import { initializeAwpHostConfigRuleDrawer } from './Drawers/AwpHostConfigRuleDrawer/AwpHostConfigRuleDrawer.initialize';

export default function initialize() {
    initializeDrawerInfoFields();
    initializeK8sRedux();
    initializeK8sPages();
    initializeK8sMenu();
    initializeK8sGetStarted();
    initializeK8SProtectedAssetDetails();
    initializeK8SProtectedAssetTable();
    addItemsToMenu();
    initialAwsEnvironmentTabs();
    initialAzureEnvironmentTabs();
    initializeEnvironmetsDefs();
    initializePolicies();
    initializeCveDrawer();
    initializeAwpHostConfigRuleDrawer();
    initializeEventsActions();
    initializeExclusionWorkload();
    initializeActiveFeatures();
}
